import images from './images';

const manicure = [
  {
    title: 'Basic Manicure',
    price: '$25',
    tags: 'Time | ~20 Min.',
  },
  {
    title: 'Gel Manicure',
    price: '$40',
    tags: 'Time | ~35 Min.',
  },
  {
    title: 'Spa Manicure',
    price: '$45',
    tags: 'Time | ~35 Min.',
  },
  {
    title: 'Serum Manicure',
    price: '$49',
    tags: 'Time | ~ Min.',
  },
  {
    title: 'SNS Dipping Powder',
    price: '$60',
    tags: 'Time | ~65 Min.',
  },
  {
    title: 'Herbal/Hot Stone Manicure',
    price: '$53',
    tags: 'Time | ~ Min.',
  },
  {
    title: 'Polish Change',
    price: '$15',
    tags: 'Time | ~10 Min.',
  },
  {
    title: 'Nail Cutting',
    price: '$12',
    tags: 'Time | ~5 Min.',
  },
   {
    title: 'Kids Manicure (11yrs & under)',
    price: '$20',
    tags: 'Time | ~15 Min.',
  },
   {
    title: 'Kids Hand Polish',
    price: '$10',
    tags: 'Time | ~5 Min.',
  },
];

const pedicure = [
  {
    title: 'Basic Pedicure',
    price: '$38',
    tags: 'Time | ~35 Min.',
  },
  {
    title: 'Divine Spa Pedicure',
    price: '$58',
    tags: 'Time | ~55 Min.',
  },
  {
    title: 'Volcano Spa Pedicure',
    price: '$66',
    tags: 'Time | ~65 Min.',
  },
  {
    title: 'Orange Peel Pedicure',
    price: '$68',
    tags: 'Time | ~65 Min.',
  },
  {
    title: 'Lemon Peel Pedicure',
    price: '$68',
    tags: 'Time | ~65 Min.',
  },
  {
    title: 'Serum Spa Pedicure',
    price: '$72',
    tags: 'Time | ~70 Min.',
  },
  {
    title: 'Herbal Spa Pedicure',
    price: '$78',
    tags: 'Time | ~75 Min.',
  },
  {
    title: 'Divine Hot Stone Spa Pedicure',
    price: '$78',
    tags: 'Time | ~75 Min.',
  },
  {
    title: 'Toe Polish Change',
    price: '$18',
    tags: 'Time | ~10 Min.',
  },
  {
    title: 'Toe Nail Cutting',
    price: '$15',
    tags: 'Time | ~5 Min.',
  },
   {
    title: 'Kids Pedicure (11yrs & under)',
    price: '$30',
    tags: 'Time | ~25 Min.',
  },
   {
    title: 'Kids Toe Polish',
    price: '$12',
    tags: 'Time | ~5 Min.',
  },
];

const fullsets = [
  {
    title: 'Acrylic Fullset',
    price: '$50',
    tags: 'Time | ~45 Min.',
  },
  {
    title: 'Acrylic Fullset w/ Gel Color',
    price: '$60',
    tags: 'Time | ~55 Min.',
  },
  {
    title: 'Acrylic Fill',
    price: '$40',
    tags: 'Time | ~45 Min.',
  },
  {
    title: 'Acrylic Gel Fill',
    price: '$50',
    tags: 'Time | ~55 Min.',
  },
  {
    title: 'Gel-X Fullset',
    price: '$75',
    tags: 'Time | ~55 Min.',
  },
  {
    title: 'Gel-X Refill',
    price: '$60',
    tags: 'Time | ~55 Min.',
  },
  {
    title: 'Liquid Gel Fullset',
    price: '$60',
    tags: 'Time | ~50 Min.',
  },
  {
    title: 'Liquid Gel Fullset w/ Gel Color',
    price: '$70',
    tags: 'Time | ~60 Min.',
  },
  {
    title: 'Liquid Gel Fill',
    price: '$45',
    tags: 'Time | ~45 Min.',
  },
  {
    title: 'Liquid Gel Fill w/ Gel Color',
    price: '$55',
    tags: 'Time | ~55 Min.',
  },
  {
    title: 'Pink & White Fullset',
    price: '$70',
    tags: 'Time | ~55 Min.',
  },
  {
    title: 'Pink & White Fill',
    price: '$60',
    tags: 'Time | ~50 Min.',
  },
  {
    title: 'Ombre Nails',
    price: '$75+',
    tags: 'Time | ~60 Min.',
  },
];

const waxing = [
  {
    title: 'Eyebrow Wax',
    price: '$14',
    tags: 'Time | ~5 Min.',
  },
  {
    title: 'Lip Wax',
    price: '$12',
    tags: 'Time | ~5 Min.',
  },
  {
    title: 'Chin Wax',
    price: '$13',
    tags: 'Time | ~5 Min.',
  },
  {
    title: 'Sideburns Wax',
    price: '$20',
    tags: 'Time | ~5 Min.',
  },
  {
    title: 'Full Face Wax',
    price: '$53',
    tags: 'Time | ~10 Min.',
  },
  {
    title: 'Half Arm Wax',
    price: '$32',
    tags: 'Time | ~5 Min.',
  },
  {
    title: 'Full Arm Wax',
    price: '$45',
    tags: 'Time | ~10 Min.',
  },
  {
    title: 'Underarm Wax',
    price: '$24',
    tags: 'Time | ~5 Min.',
  },
  {
    title: 'Half Leg Wax',
    price: '$45',
    tags: 'Time | ~5 Min.',
  },
  {
    title: 'Full Leg Wax',
    price: '$60',
    tags: 'Time | ~10 Min.',
  },
  {
    title: 'Back Wax',
    price: '$55',
    tags: 'Time | ~15 Min.',
  },
  {
    title: 'Chest Wax',
    price: '$35',
    tags: 'Time | ~10 Min.',
  },
  {
    title: 'Bikini Wax',
    price: '$35',
    tags: 'Time | ~10 Min.',
  },
  {
    title: 'Brazilian Wax',
    price: '$65',
    tags: 'Time | ~15 Min.',
  },
];

const misc = [

];

const addons = [
  {
    title: 'Extra Foot Massage',
    price: '$8',
    tags: 'Time | 5 Min.',
  },
  {
    title: 'Extra Foot Massage',
    price: '$14',
    tags: 'Time | 10 Min.',
  },
  {
    title: 'Extra Foot Massage',
    price: '$19',
    tags: 'Time | 15 Min.',
  },
  {
    title: 'Gel Add On',
    price: '$20',
    tags: 'Time | ~ Min.',
  },
  {
    title: 'French',
    price: '$8',
    tags: 'Time | ~ Min.',
  },
  {
    title: 'Callus Treatment',
    price: '$8',
    tags: 'Time | ~ Min.',
  },
  {
    title: 'Collagen Gloves',
    price: '$10',
    tags: 'Time | ~5 Min.',
  },
  {
    title: 'Paraffin Treatments',
    price: '$10 - $12',
    tags: 'Depending on Hand or Feet',
  },
];
  const face = [
    {
    title: 'Mini Facial',
    price: '$50',
    tags: 'Time | ~30 Min.',
  },
  {
    title: 'Full Facial',
    price: '$80',
    tags: 'Time | ~60 Min.',
  },
  {
    title: 'Eyelash Tinting',
    price: '$40',
    tags: 'Time | ~ Min.',
  },
  {
    title: 'Eyebrow Tinting',
    price: '$35',
    tags: 'Time | ~ Min.',
  },
  {
    title: 'Classic Lash Extension',
    price: '$120',
    tags: 'Time | ~ Min.',
  },
  {
    title: 'Russian Volume Lash Extension',
    price: '$150',
    tags: 'Time | ~ Min.',
  },
  {
    title: 'Lash Refill',
    price: '$',
    tags: 'Time | ~ Min.',
  },
  {
    title: 'Lash Lift',
    price: '$50',
    tags: 'Time | ~ Min.',
  },
];



const technicians = [
  {
    imgUrl: images.spa,
    title: 'Ann',
    subtitle: 'Female Technician',
  },
  {
    imgUrl: images.spa,
    title: 'Azia',
    subtitle: 'Female Technician',
  },
  {
    imgUrl: images.spa,
    title: 'Chi',
    subtitle: 'Female Technician',
  },
  {
    imgUrl: images.spa,
    title: 'Dan',
    subtitle: 'Male Technician',
  },
  {
    imgUrl: images.spa,
    title: 'Julie',
    subtitle: 'Female Technician',
  },
  {
    imgUrl: images.spa,
    title: 'Jenny',
    subtitle: 'Female Technician',
  },
  {
    imgUrl: images.spa,
    title: 'Lynda',
    subtitle: 'Female Technician',
  },
  {
    imgUrl: images.spa,
    title: 'Mindy',
    subtitle: 'Female Technician',
  },
  {
    imgUrl: images.spa,
    title: 'Noppa',
    subtitle: 'Female Technician',
  },
  {
    imgUrl: images.spa,
    title: 'Hannah',
    subtitle: 'Female Technician',
  },
  {
    imgUrl: images.spa,
    title: 'Toni',
    subtitle: 'Male Technician',
  },
  {
    imgUrl: images.spa,
    title: 'Laura',
    subtitle: 'Female Technician',
  },
  {
    imgUrl: images.spa,
    title: 'Tracy',
    subtitle: 'Female Technician',
  },
];

export default { manicure, pedicure, fullsets, waxing, misc, addons, face, technicians};
